import { OrderEntity, OrderMissionEntity } from '@src/features/order/entities';

export const isNewOrder = (order: OrderEntity | OrderMissionEntity | null): order is OrderEntity => {
  return Boolean((order as OrderEntity)?.id);
};